export const GET_TITLE_BEGIN = "GET_TITLE_BEGIN"
export const GET_TITLE_SUCCESS = "GET_TITLE_SUCCESS"